import { useEffect, useState } from "react";
import { useData } from "../../../context/DataProvider";
import PercentageBar from "../../PercentageBar/PercentageBar";
import "./index.scss";
import { DefaultizedPieValueType, PieChart, pieArcLabelClasses } from "@mui/x-charts";
const DecarbonizedSystem = (props: {scenario: string}) => {
    const { decarbonSystem } = useData()!; 
    const [currentScenario, setCurrentScenario] = useState<any[]>();
    useEffect(()=>{
        setCurrentScenario(decarbonSystem?.filter((item)=>item.Scenario===props.scenario))
    }, [decarbonSystem, props.scenario])

    const [tableMap, setTableMap] = useState(new Map());
    const [nameplate, setNameplate] = useState<any>([]);
    const [percentage, setPercentage] = useState<string>("0");
    const [systemCost, setSystemCost] = useState<string>("0");
    const [total, setTotal] = useState<number>(1);
    const [renewables, setRenewables] = useState<number>(1);
    const [landscape, setLandscape] = useState<boolean>(true);
    //console.log(currentScenario);

    useEffect(()=>{
        if(window.innerHeight > window.innerWidth)
            setLandscape(false);
        else
            setLandscape(true);

    }, [window.innerHeight, window.innerWidth])
    
    const colorAssign = (color: string) => {
        switch(color){
            case "Hydro":
                return "#B7D3E4";
            case "Solar":
                return "#EEBF66";
            case "Wind":
                return "#007AE4";
            case "Storage":
                return "#C34B46";
            case "Natrium":
                return "#203C5B";
        }
    }
    const numberCheck = (num: any) => {
        if(!Number.isNaN(+num))
            return num;
        else
            return(parseInt(num.replace(",","")));
    }
    const PieLegend = () => {
        return(
        <div className="pie-legend">
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Hydro")}}/>
                <span>Hydro</span>
            </div>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Solar")}}/>
                <span>Solar</span>
            </div>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Wind")}}/>
                <span>Wind</span>
            </div>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Natrium")}}/>
                <span>Natrium</span>
            </div>
        </div>
        )
    }

    const tempTableMap = new Map();
    const tempNameplate: { value: any; label: any; color: string | undefined; }[] = [];
    let tempCost = 0;
    let tempTotal = 0;
    let tempRenewables = 0;
    useEffect(()=>{
        currentScenario?.forEach((dataMember)=>{
            if(dataMember?.Variable === "Generation Mix"){
                tempNameplate.push({
                    value: numberCheck(dataMember?.Value),
                    label: dataMember?.Type,
                    color: colorAssign(dataMember?.Type)
                })
                if(["Hydro", "Solar", "Wind"].includes(dataMember?.Type))
                    tempRenewables+=(numberCheck(dataMember?.Value));
                tempTotal+=(numberCheck(dataMember?.Value));

            }
            if(dataMember?.Variable === "Nameplate"){
                if (tempTableMap.has(dataMember.Type)) {
                    // If the key already exists, update the existing object
                    const existingEntry = tempTableMap.get(dataMember.Type);
                    existingEntry.nameplate = dataMember.Value;
                  } else {
                    // Otherwise, set a new entry
                    tempTableMap.set(dataMember.Type, {
                      nameplate: dataMember.Value
                    });
                }
                
            }
            if(dataMember?.Variable === "Firm Capacity"){
                if (tempTableMap.has(dataMember.Type)) {
                    // If the key already exists, update the existing object
                    const existingEntry = tempTableMap.get(dataMember.Type);
                    existingEntry.firm = dataMember.Value;
                  } else {
                    // Otherwise, set a new entry
                    tempTableMap.set(dataMember.Type, {
                        firm: dataMember.Value
                    });
                }
            }
            if(dataMember?.Variable === "Total Area"){
                if (tempTableMap.has(dataMember.Type)) {
                    // If the key already exists, update the existing object
                    const existingEntry = tempTableMap.get(dataMember.Type);
                    existingEntry.area = dataMember.Value;
                  } else {
                    // Otherwise, set a new entry
                    tempTableMap.set(dataMember.Type, {
                        area: dataMember.Value
                    });
                }
            }
            if(dataMember?.Variable === "Total Cost"){
                tempCost = numberCheck(dataMember?.Value).toFixed(1);
            }
        })
        setNameplate(tempNameplate);
        setTableMap(tempTableMap);
        setSystemCost(`$${tempCost}`);
        if(tempRenewables > 0 && tempTotal > 0){
            setTotal(()=>{
                return tempTotal
            })
            setPercentage(()=>{
                return (tempRenewables/tempTotal*100).toFixed(1)+"";
            })
        }
    }, [decarbonSystem, currentScenario])
    const getArcLabel = (params: DefaultizedPieValueType) => {
        const percent = params.value;
        return `${(percent * 100).toFixed(0)}%`;
    };
    const roundAndAddCommas = (value: number) => {
        return value?.toLocaleString("en-US", {
            maximumFractionDigits: 0,  
        })
    }
    const displayPercentage = (value: number) => {
        return (value * 100)?.toFixed(0) + "%";
    }
    console.log("Current table", tableMap);
    //console.log("Percentage?", percentage)
    return(
        <div className={`decarbon-systemR`}>
            <p className="header">2050 DECARBONIZED ENERGY SYSTEM</p>    
            <div className="left-half">
                <div className="pie-chart-wrapper">
                    <PieChart 
                    series={[
                        {
                            data : nameplate, 
                            innerRadius: 70, 
                            outerRadius: 145,
                            arcLabel: getArcLabel,
                            arcLabelMinAngle: 5, 
                            sortingValues: "asc",
                            cy: "51.5%",
                            cx: landscape ? "65%" : "73%",
                        }
                    ]} 
                    slotProps={{legend: {position: {vertical: "bottom", horizontal: "middle"}, hidden: true}}}
                    />
                    {decarbonSystem && <div className="pie-center-label">
                        <span className="top">
                        {`System Cost\n$/MWh`}
                        </span>
                        <span className="bottom">
                        {systemCost}
                        </span>
                    </div>}    
                </div>
                <PieLegend />
            </div>
            <div className="right-half">
                <PercentageBar percentage={percentage+"%"} color1="#387C2B" color2="#203C5B"/>
                <div className="label-icons">
                    <div className="icon-wrapper">
                        <div className="circle" style={{backgroundColor: "#387C2B"}}/>
                        <span>Renewables</span>
                    </div>
                    <div className="icon-wrapper">
                        <div className="circle" style={{backgroundColor: colorAssign("Natrium")}}/>
                        <span>Natrium</span>
                    </div>
                </div>
                {landscape && <div className="base-table">
                    <div className="table-row table-header">
                        <div />
                        <span>TOTAL NAMEPLATE</span> 
                        <span>TOTAL ENERGY MIX</span>
                        <span>AREA(mi2)</span>
                    </div>
                    <div className="table-row">
                        <span>NATRIUM</span>
                        <span>{roundAndAddCommas(tableMap?.get("Natrium")?.nameplate)}</span>
                        <span>{displayPercentage(tableMap?.get("Natrium")?.firm)}</span>
                        <span>{roundAndAddCommas(tableMap?.get("Natrium")?.area)}</span>
                    </div>
                    <div className="table-row">
                        <span>SOLAR</span>
                        <span>{roundAndAddCommas(tableMap?.get("Solar")?.nameplate)}</span>
                        <span>{displayPercentage(tableMap?.get("Solar")?.firm)}</span>
                        <span>{roundAndAddCommas(tableMap?.get("Solar")?.area)}</span>
                    </div>
                    <div className="table-row">
                        <span>WIND</span>
                        <span>{roundAndAddCommas(tableMap?.get("Wind")?.nameplate)}</span>
                        <span>{displayPercentage(tableMap?.get("Wind")?.firm)}</span>
                        <span>{roundAndAddCommas(tableMap?.get("Wind")?.area)}</span>
                    </div>
                    <div className="table-row">
                        <span>HYDRO</span>
                        <span>{roundAndAddCommas(tableMap?.get("Hydro")?.nameplate)}</span>
                        <span>{displayPercentage(tableMap?.get("Hydro")?.firm)}</span>
                        <span>{roundAndAddCommas(tableMap?.get("Hydro")?.area)}</span>
                    </div>
                    <div className="table-row">
                        <span>STORAGE</span>
                        <span>{roundAndAddCommas(tableMap?.get("Storage")?.nameplate)}</span>
                        <span>{displayPercentage(tableMap?.get("Storage")?.firm ?? 0)}</span>
                        <span>{roundAndAddCommas(tableMap?.get("Storage")?.area)}</span>
                    </div>
                </div>}

                {!landscape && 
                <div className="three-tables">
                    <div className="tableP">
                        <div className="table-row table-header">
                            <span />
                            <span>TOTAL NAMEPLATE</span>
                        </div>
                        <div className="table-row">
                            <span>NATRIUM</span>
                            <span>{roundAndAddCommas(tableMap?.get("Natrium")?.nameplate)}</span>
                        </div>
                        <div className="table-row">
                            <span>SOLAR</span>
                            <span>{roundAndAddCommas(tableMap?.get("Solar")?.nameplate)}</span>
                        </div>
                        <div className="table-row">
                            <span>WIND</span>
                            <span>{roundAndAddCommas(tableMap?.get("Wind")?.nameplate)}</span>
                        </div>
                        <div className="table-row">
                            <span>HYDRO</span>
                            <span>{roundAndAddCommas(tableMap?.get("Hydro")?.nameplate)}</span>
                        </div>
                        <div className="table-row">
                            <span>STORAGE</span>
                            <span>{roundAndAddCommas(tableMap?.get("Storage")?.nameplate)}</span>
                        </div>
                    </div>
                    <div className="tableP">
                        <div className="table-row table-header">
                            <div />
                            <span>TOTAL ENERGY MIX</span>
                        </div>
                        <div className="table-row">
                            <span>NATRIUM</span>
                            <span>{displayPercentage(tableMap?.get("Natrium")?.firm)}</span>
                        </div>
                        <div className="table-row">
                            <span>SOLAR</span>
                            <span>{displayPercentage(tableMap?.get("Solar")?.firm)}</span>
                        </div>
                        <div className="table-row">
                            <span>WIND</span>
                            <span>{displayPercentage(tableMap?.get("Wind")?.firm)}</span>
                        </div>
                        <div className="table-row">
                            <span>HYDRO</span>
                            <span>{displayPercentage(tableMap?.get("Hydro")?.firm)}</span>
                        </div>
                        <div className="table-row">
                            <span>STORAGE</span>
                            <span>{displayPercentage(tableMap?.get("Storage")?.firm ?? 0)}</span>
                        </div>
                    </div>
                    <div className="tableP">
                        <div className="table-row table-header">
                            <div />
                            <span>AREA(mi2)</span>
                        </div>
                        <div className="table-row">
                            <span>NATRIUM</span>
                            <span>{roundAndAddCommas(tableMap?.get("Natrium")?.area)}</span>
                        </div>
                        <div className="table-row">
                            <span>SOLAR</span>
                            <span>{roundAndAddCommas(tableMap?.get("Solar")?.area)}</span>
                        </div>
                        <div className="table-row">
                            <span>WIND</span>
                            <span>{roundAndAddCommas(tableMap?.get("Wind")?.area)}</span>
                        </div>
                        <div className="table-row">
                            <span>HYDRO</span>
                            <span>{roundAndAddCommas(tableMap?.get("Hydro")?.area)}</span>
                        </div>
                        <div className="table-row">
                            <span>STORAGE</span>
                            <span>{roundAndAddCommas(tableMap?.get("Storage")?.area)}</span>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default DecarbonizedSystem;